import {
  ImageProps,
  PixelDensity,
} from 'libs/growth-platform-brand-system-v2/src/components/Image/types';
import { createSchema } from 'morphism';

export const schemaImage = createSchema<Omit<ImageProps, 'sizes'>, any>({
  alt: {
    path: 'alt',
    fn: (propertyValue: string, source: any) => {
      return propertyValue || source?.altDefault || '';
    },
  },
  width: 'width',
  height: 'height',
  src: 'url',
  loading: {
    path: ['loading', 'isHeader'],
    fn: ({ loading, isHeader }: any) => {
      if (isHeader) {
        return 'eager';
      }
      return loading || 'lazy';
    },
  },
  pixelDensity: {
    path: 'pixelDensity',
    fn: (propertyValue: PixelDensity) => {
      return propertyValue || 'default';
    },
  },
});
